export const WHATSAPP_ADQUIRA_HREF = '#whatsapp';

export const WHATSAPP_LINK =
  'https://api.whatsapp.com/send/?phone=551151288893&text=Quero+falar+com+um+consultor+sobre+os+produtos+Caixa+Pr%C3%A9-Pagos.';
